// app/javascript/utils/roleHelper.js
export const hasRole = (user, roleName) => {
  if (!user || !user.roles) return false;
  return user.roles.some(role => role.name === roleName);
};

export const hasAnyRole = (user, roleNames) => {
  if (!user || !user.roles) return false;
  return roleNames.some(roleName => hasRole(user, roleName));
};

export const hasAllRoles = (user, roleNames) => {
  if (!user || !user.roles) return false;
  return roleNames.every(roleName => hasRole(user, roleName));
};
